import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Contact } from '../../interfaces/contact';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { GlobalService } from '../../services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { constants } from '../../../assets/constants';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit, AfterViewInit {
  canCreate: boolean;
  canDelete: boolean;
  canModify: boolean;

  contactList: any;

  displayedColumns = ['name', 'email', 'phone', 'country', 'actions'];
  dataSource = new MatTableDataSource;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  constructor(private route: ActivatedRoute,
    private globalService: GlobalService,
    private translate: TranslateService,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.contactList = this.route.snapshot.data.contactList;

    this.translate.get('CONTACTS.TITLE').subscribe((translation) => {
      this.globalService.changePageTitle([translation]);
    });

    this.canCreate = this.authService.isInRole(constants.roles.contact_create);
    this.canModify = this.authService.isInRole(constants.roles.contact_modify);
    this.canDelete = this.authService.isInRole(constants.roles.contact_delete);
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.contactList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.firstPage();
    this.dataSource.sort = this.sort;
  }

}
